module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/spice-market_8b92df.jpg";